import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ThemeService } from '../../../../Utils/_services/theme/theme.service';

@Component({
  selector: 'user-footer',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './admin-footer.component.html',
  styleUrl: './admin-footer.component.css'
})
export class FooterComponent {
  
  //properties
  currentYear: number = new Date().getFullYear();

  constructor(public themeService: ThemeService) {}
}
